import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FilterComponent } from './components/filter/filter.component';
import { NavEntry } from './components/tree-navigation/nav-entry';


@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss', '../unity/css/em-unity-1.7.1.min.css']
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('startDrawer') private startDrawer!: MatDrawer;
  @ViewChild('startDrawer') private endDrawer!: MatDrawer;
  @ViewChild('filter') private filter!: FilterComponent;

  env = environment.name;
  hideStartDrawer = false;
  hideEndDrawer = false;

  private navigationSubscription!: Subscription;

  navRoutes: NavEntry[] = [
    { label: 'Exposure Vendor Quote Mapping', route: '/vendorQuoteMapping' },
    { label: 'Commodity Currency & UOM Mapping', route: '/currencyUomMapping' },
    { label: 'Curve Mapping', route: '/curveMapping' },
  ]

  constructor(private router: Router) { }

  ngOnInit(): void {

    this.navigationSubscription = this.router.events.pipe(filter(ev => ev instanceof NavigationEnd)).subscribe(() => {
      this.startDrawer.close();
      this.filter.clearFilter();
    })
  }

  ngOnDestroy(): void {
    this.navigationSubscription?.unsubscribe();
  }
}
